import { combineReducers } from 'redux';
import SidePanReducer from './SidePanReducer';
import MMPLDashboardReducer from './MMPLDashboardReducer';
import ShipViewReducer from './ShipViewReducer';
import POViewReducer from './ShipManagementReducer';
import DeviceManagementReducer from './DeviceManagementReducer';
import PageLoaderReducer from './PageLoaderReducer';
import CrewManagementReducer from './CrewManagementReducer';
import UserManageReducer from './UserManageReducer';
import SpecialAccessUserManageReducer from './SpecialAccessUserManageReducer';
import MasterScreenReducer from './MasterScreenReducer';
import RankManagementReducer from './RankManagementReducer';
import VisitorManagementReducer from './VisitorManagementReducer';
import ShippingSettingsReducer from './ShippingSettingsReducers';

const rootReducer = combineReducers({
    SidePanReducer,
    MMPLDashboardReducer,
    ShipViewReducer,
    DeviceManagementReducer,
    POViewReducer,
    PageLoaderReducer,
    CrewManagementReducer,
    UserManageReducer,
    SpecialAccessUserManageReducer,
    MasterScreenReducer,
    RankManagementReducer,
    VisitorManagementReducer,
    ShippingSettingsReducer
});
export default rootReducer;
